// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AppStoreInput_wrapper_343Zc","label":"AppStoreInput_label_1f7Ly","explanation":"AppStoreInput_explanation_WL6e5","error":"AppStoreInput_error_372ni"};